/** Presentation opt-in; a global row never enables a tenant. */
export const ROSTER_SAH_SCHEDULE_GRID_FLAG = 'roster_sah_schedule_grid_v1';
export function isTenantScopedSahScheduleGridFlag(key: string | null | undefined): boolean {
  return key === ROSTER_SAH_SCHEDULE_GRID_FLAG;
}
